class chooseMyCable {

    constructor(swiper) {
        this.swiper                      = swiper;
        this.containerSliderChooseACable = document.getElementById("choose-a-cable-section");
        this.btns                        = this.containerSliderChooseACable.getElementsByClassName("second-container");
        this.sliderItems                 = this.containerSliderChooseACable.getElementsByClassName("main-content");
        this.containerBtnBackBottom      = this.containerSliderChooseACable.getElementsByClassName("container-btn-choose-my-cable");
        this.body                        = document.querySelector("body");
        this.navbarStart                 = document.querySelector(".navbar-start");
        this.navbarBrand                 = document.querySelector(".navbar-brand");
        this.sliderItemsEuroclass        = document.querySelectorAll(".slide-euroclass");
        this.nextBtnEuroclass            = document.querySelectorAll(".next-btn-euroclass");
        this.previousTopBtnEuroclass     = document.querySelectorAll(".sbn-euroclass");
        this.euroclassContainer          = document.querySelectorAll(".spec-euroclass-container");
        this.cableTypeEuroclass          = document.querySelectorAll(".cable-type-euroclass");
        this.euroclassTypeContainer      = document.querySelector(".euroclass-type-container");
        this.containersFirstSlide        = this.euroclassTypeContainer.querySelectorAll(".spec-euroclass-container");
        this.containerCablesEuroclass    = document.querySelector(".container-cables-euroclass");
        this.containersSecondSlide       = this.containerCablesEuroclass.querySelectorAll(".spec-euroclass-container");
        this.errorListEuroclass          = document.getElementById("error-form-list-euroclass");
        this.errorCableEuroclass         = document.getElementById("error-form-cable-euroclass");
        this.backResultsBtn              = document.getElementById("back-results");
        this.formResults                 = document.getElementById("buildings-form");
        this.slides                      = this.formResults.querySelectorAll(".main-content");
        this.slideResults                = document.querySelector('.slide6');
        this.firstSlide                  = this.containerSliderChooseACable.querySelector('.slide0');
        this.backResultsEuroclassBtn     = document.getElementById("back-results-euroclass");
        this.slidesEuroclass             = document.querySelectorAll('.slide-euroclass');
        this.slideResultsEuroclass       = document.querySelector('.slide9');
        this.backResultsBottomBtn        = document.getElementById('back-btn-results');
        this.firstSlideListener          = null;
        this.choiceSlideOne              = null;
        this.choiceSlideTwo              = null;
        this.firePerformance             = document.getElementById("fire-performance");
        this.euroclassResults            = document.getElementById("euroclass-results");
        this.cableTypeResults            = document.getElementById("cable-type-results");
        this.cableFamilyResults          = document.getElementById("cable-family-results");
        this.mySwiperVertical            = document.querySelector('main > .swiper-container').swiper;
        this.header                      = document.getElementById('header');
        this.slideAnimationTime          = 500;

        this.perf        = null;
        this.cableFamily = null;
        this.cableType   = null;
        this.euroclass   = null;

        this.slideEuroclassChoice = null;

        this.manageTheSlider();
        this.manageRadio();
        this.manageNextBtnEuroclass();
        this.managePreviousTopBtnEuroclass();
        this.manageBackResultsBtn();
        this.manageBackResultsEuroclassBtn();
        this.manageBackResultsEuroclassBottomBtn();
        // this.manageBackBottomResultsBtn();
    }

    manageTheSlider() {

        for (let i = 0; i < this.btns.length; i++) {

            this.btns[i].addEventListener("click", (e) => {

                e.preventDefault();

                this.body.classList.add("slider-is-active");
                this.navbarStart.classList.remove('is-clicked');

                if (!this.header.classList.add(this.swiper.slides[this.swiper.activeIndex].id)) {
                    this.header.classList.add(this.swiper.slides[this.swiper.activeIndex].id);
                }

                if (i === 0) {
                    this.sliderItems[0].classList.add("active");
                    this.sliderItems[1].classList.add("active");
                    this.firstSlideListener = new SlideListeners(document.getElementById("choose-a-cable-section").querySelectorAll('.main-content'));
                    this.mySwiperVertical.mousewheel.disable();
                    this.header.classList.add('set-bg');
                    // prevent the user to scroll vertically when the horizontal slider is active
                    this.mySwiperVertical.allowSlideNext = false;
                    this.mySwiperVertical.allowSlidePrev = false;

                    // allow the user to scroll through the current section
                    this.mySwiperVertical.mousewheel.disable();
                    this.mySwiperVertical.detachEvents();
                }

                if (i === 1) {
                    this.sliderItems[0].classList.add("active");
                    this.sliderItemsEuroclass[0].classList.add("active");
                    this.mySwiperVertical.mousewheel.disable();
                    this.header.classList.add('set-bg');

                    // prevent the user to scroll vertically when the horizontal slider is active
                    this.mySwiperVertical.allowSlideNext = false;
                    this.mySwiperVertical.allowSlidePrev = false;

                    // allow the user to scroll through the current section
                    this.mySwiperVertical.mousewheel.disable();
                    this.mySwiperVertical.detachEvents();
                }

                // Removes all the reset classes
                for (let j = 0; j < this.sliderItems.length; j++) {
                    if (this.sliderItems[j].classList.contains("reset")) {
                        this.sliderItems[j].classList.remove("reset");
                    }
                }

                setTimeout(() => {
                    this.navbarStart.classList.add("green-is-active");
                }, 50);

                setTimeout(() => {
                    this.navbarBrand.classList.add("active-slide");
                }, 300);

            });
        }
    }

    manageNextBtnEuroclass() {
        this.nextBtnEuroclass[0].addEventListener("click", () => {
            this.choiceSlideOne     = this.slideEuroclassChoice;
            const BASIC_PERFORMANCE = 3;

            if (this._isFormValid(this.containersFirstSlide)) {
                this.sliderItemsEuroclass[0].classList.add("inactive");
                this.sliderItemsEuroclass[0].classList.remove("active");
                this.sliderItemsEuroclass[1].classList.add("active");
                //this.slideEuroclassChoice = null;
                if (parseInt(this.choiceSlideOne) === BASIC_PERFORMANCE) {
                    for (let i = 0; i < this.cableTypeEuroclass.length; i++) {
                        this.cableTypeEuroclass[i].querySelector(".perf-ec").classList.add("active-show");
                    }
                }
            } else {
                this.errorListEuroclass.classList.add("active");
            }
        });


        this.nextBtnEuroclass[1].addEventListener("click", () => {
            this.choiceSlideTwo = this.slideEuroclassChoice;
            if (this._isFormValid(this.containersSecondSlide)) {
                this.sliderItemsEuroclass[1].classList.add("inactive");
                this.sliderItemsEuroclass[2].classList.add("active");


                switch (true) {

                    // OPTIMAL CASE
                    case (parseInt(this.choiceSlideOne) === 1):
                        this.perf      = "Optimale";
                        this.euroclass = "B2ca-s1a, d1, a1";

                        switch (true) {
                            case (parseInt(this.choiceSlideTwo) === 1):
                                this.cableFamily = "<p>K22 et K25</p>";
                                this.cableType   = "Câbles d'énergie";
                                break;

                            case (parseInt(this.choiceSlideTwo) === 2):
                                this.cableFamily = "<p>K26, K23, K24 et K209</p> <p>SF/FTP, S/FTP, F/FTP, U/FTP</p> <p>Câble Fibre optique</p>";
                                this.cableType   = "Câbles de communication";
                                break;
                        }

                        break;

                    // IMPROVED CASE
                    case (parseInt(this.choiceSlideOne) === 2):
                        this.perf      = "Améliorée";
                        this.euroclass = "Cca-s1, d1, a1";

                        switch (true) {
                            case (parseInt(this.choiceSlideTwo) === 1):
                                this.cableFamily = "<p>FR-N1X1G1, FR-N1X1X2,H07 Z1-R,</p> <p>H07 Z1-K, H07 Z1-U, H07 ZZ-F</p>";
                                this.cableType   = "Câbles d'énergie";
                                break;

                            case (parseInt(this.choiceSlideTwo) === 2):
                                this.cableFamily = "<p>SYT</p> <p>SF/FTP, S/FTP, F/FTP, U/FTP, SF/UTP, F/UTP, U/UTP,</p> <p>Câble à FO de raccordement</p>";
                                this.cableType   = "Câbles de communication";
                                break;
                        }

                        break;

                    // BASIC CASE
                    case (parseInt(this.choiceSlideOne) === 3):
                        this.perf = "Basique";

                        switch (true) {
                            case(parseInt(this.choiceSlideTwo) === 1):
                                this.euroclass   = "Eca";
                                this.cableFamily = "<p>U1000 R2V, U1000 AR2V,</p><p>H07 V-U, H07 V-R, H07 V-K</p><p>H07 RN-F</p>";
                                this.cableType   = "Câbles d'énergie";
                                break;

                            case(parseInt(this.choiceSlideTwo) === 2):
                                this.euroclass   = "Dca-s2, d2, a2";
                                this.cableFamily = "<p>SYT</p><p>SF/FTP, S/FTP, F/FTP, U/FTP, SF/UTP, F/UTP, U/UTP</p><p>Câble FO de distribution à extractibilité permanente</p><p>Câble à FO de distribution</p>";
                                this.cableType   = "Câbles de communication";
                                break;
                        }

                        break;
                }

                this.firePerformance.textContent  = this.perf;
                this.euroclassResults.textContent = this.euroclass;
                this.cableTypeResults.textContent = this.cableType;
                this.cableFamilyResults.innerHTML = this.cableFamily;
            } else {
                this.errorCableEuroclass.classList.add("active");
            }
        });
    }

    _isFormValid(slideContainer) {
        for (let i = 0; i < slideContainer.length; i++) {
            if (slideContainer[i].querySelector("input[type=radio").checked === true) {
                return true;
            }
        }
    }

    managePreviousTopBtnEuroclass() {
        this.perf        = null;
        this.euroclass   = null;
        this.cableType   = null;
        this.cableFamily = null;
        this._resetClasses(0);
        this._resetClasses(1);

    }

    _resetClasses(slideNumber) {
        this.previousTopBtnEuroclass[slideNumber].addEventListener("click", () => {

            // allow the user to scroll between each sections
            this.mySwiperVertical.allowSlideNext = true;
            this.mySwiperVertical.allowSlidePrev = true;

            // prevent the user to scroll through the current section
            this.mySwiperVertical.mousewheel.enable();
            this.mySwiperVertical.attachEvents();

            this.header.classList.add('slide-out');
            this.mySwiperVertical.mousewheel.enable();
            this.sliderItems[0].classList.remove("inactive");
            this.sliderItems[0].classList.remove("active");
            this.sliderItemsEuroclass[0].classList.remove("inactive");
            this.sliderItemsEuroclass[0].classList.remove("active");
            this.sliderItemsEuroclass[1].classList.remove("inactive");
            this.sliderItemsEuroclass[1].classList.remove("active");

            if (slideNumber === 1) {
                this.sliderItemsEuroclass[0].classList.add("hidden");
                setTimeout(() => {
                    this.sliderItemsEuroclass[0].classList.remove('hidden');
                }, 400);
            }

            document.querySelector("body").classList.remove("slider-is-active");

            for (let i = 0; i < this.cableTypeEuroclass.length; i++) {
                this.cableTypeEuroclass[i].querySelector(".perf-ec").classList.remove("active-show");
            }

            this.navbarBrand.classList.remove("active-slide");
            setTimeout(() => {
                this.navbarStart.classList.remove("green-is-active");
                this.header.classList.remove('slide-out');
                this.header.classList.remove('set-bg');
            }, 400);
        });
    }

    manageRadio() {
        for (let i = 0; i < this.euroclassContainer.length; i++) {
            this.euroclassContainer[i].addEventListener("click", (e) => {
                const CURRENT_TARGET                                      = e.currentTarget;
                CURRENT_TARGET.querySelector('input[type=radio]').checked = true;

                // Parse active elements to remove active class
                const ACTIVE_ELEMENTS = CURRENT_TARGET.parentElement.querySelectorAll('.active');
                for (let i = 0; i < ACTIVE_ELEMENTS.length; i++) {
                    ACTIVE_ELEMENTS[i].classList.remove('active');
                }
                CURRENT_TARGET.classList.add('active');

                // remove the error message if a choice has been made
                this.errorListEuroclass.classList.remove("active");
                this.errorCableEuroclass.classList.remove("active");

                this.slideEuroclassChoice = CURRENT_TARGET.querySelector('input[type=radio]').value;

            });
        }
    }

    // top back button ouvrage type RESULTS SLIDE
    manageBackResultsBtn() {
        this.backResultsBtn.addEventListener('click', () => {
            this.header.classList.add('slide-out');
            this.mySwiperVertical.mousewheel.enable();

            // allow the user to scroll between each sections
            this.mySwiperVertical.allowSlideNext = true;
            this.mySwiperVertical.allowSlidePrev = true;

            // prevent the user to scroll through the current section
            this.mySwiperVertical.mousewheel.enable();
            this.mySwiperVertical.attachEvents();

            for (let i = 0; i < this.slides.length; i++) {
                this.slides[i].classList.remove("active");
                this.slides[i].classList.remove("inactive");
                this.slides[i].classList.add("reset");
                this.slides[i].classList.add('hidden');
                setTimeout(() => {
                    this.slides[i].classList.remove('hidden');
                }, 400);
            }

            setTimeout(() => {
                this.header.classList.remove('set-bg');
                this.header.classList.remove('slide-out');
            }, 500);

            this.slideResults.classList.remove('active');
            this.firstSlide.classList.remove('active');
            this.body.classList.remove('slider-is-active');
            this.navbarBrand.classList.remove('active-slide');
            this.navbarStart.classList.remove('green-is-active');

            // allow the user to scroll between each sections
            this.mySwiperVertical.allowSlideNext = true;
            this.mySwiperVertical.allowSlidePrev = true;

            // prevent the user to scroll through the current section
            this.mySwiperVertical.mousewheel.enable();
            this.mySwiperVertical.attachEvents();
        });
    }

    // top back btn euroclass RESULTS SLIDE
    manageBackResultsEuroclassBtn() {
        this.backResultsEuroclassBtn.addEventListener('click', () => {
            this.mySwiperVertical.mousewheel.enable();
            this.header.classList.add('slide-out');

            // allow the user to scroll between each sections
            this.mySwiperVertical.allowSlideNext = true;
            this.mySwiperVertical.allowSlidePrev = true;

            // prevent the user to scroll through the current section
            this.mySwiperVertical.mousewheel.enable();
            this.mySwiperVertical.attachEvents();

            for (let i = 0; i < this.slidesEuroclass.length; i++) {
                this.slidesEuroclass[i].classList.remove("active");
                this.slidesEuroclass[i].classList.remove("inactive");
                this.slidesEuroclass[i].classList.add("reset");
                this.slidesEuroclass[0].classList.add('hidden');
                this.slidesEuroclass[1].classList.add('hidden');
                setTimeout(() => {
                    this.slidesEuroclass[0].classList.remove('hidden');
                    this.slidesEuroclass[1].classList.remove('hidden');
                }, 400);
            }

            setTimeout(() => {
                this.header.classList.remove('set-bg');
                this.header.classList.remove('slide-out');
            }, 500);

            this.body.classList.remove('slider-is-active');
            this.firstSlide.classList.remove('active');
            this.navbarBrand.classList.remove('active-slide');
            this.navbarStart.classList.remove('green-is-active');
            this.slideResultsEuroclass.classList.remove('active');
        });
    }

    // bottom back euroclass btn RESULTS SLIDE
    manageBackResultsEuroclassBottomBtn() {
        for (let i = 0; i < this.slidesEuroclass.length; i++) {
            this.slidesEuroclass[i].querySelector('.container-btn-choose-my-cable').querySelector('.back').addEventListener('click', () => {
                this.slidesEuroclass[i - 1].classList.remove('inactive');
                this.slidesEuroclass[i - 1].classList.add('active');
                this.slidesEuroclass[i].classList.remove('active');
            });
        }
    }
}